import fetch from 'isomorphic-fetch';
import networkErrorFactory from './networkErrors';

export const GET_METHOD = 'GET';
export const POST_METHOD = 'POST';
export const PUT_METHOD = 'PUT';
export const DELETE_METHOD = 'DELETE';
export const PATCH_METHOD = 'PATCH';

class NetworkLayer {
  static JsonHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  set authToken(token) {
    this._token = token;
  }

  /**
   * Make get request
   *
   * @param {String} url
   * @param {Object} params
   * @returns {*}
   */
  async getJson(url, params) {
    url = params ? url + '?' + this.prepareParams(params) : url;
    let response = await this.request(GET_METHOD, url);
    return await this._parseJsonBody(response);
  }

  postJson(url, data = {}) {
    return this.json(POST_METHOD, url, {
      body: JSON.stringify(data)
    });
  }

  putJson(url, data = {}) {
    return this.json(PUT_METHOD, url, {
      body: JSON.stringify(data)
    });
  }

  removeJson(url, data = {}) {
    return this.json(DELETE_METHOD, url, {
      body: JSON.stringify(data)
    });
  }

  patchJSON(url, data = {}) {
    return this.json(PATCH_METHOD, url, {
      body: JSON.stringify(data)
    });
  }

  /**
   * Make json call to server
   *
   * @param method
   * @param url
   * @param headers
   * @param body
   * @returns {*}
   */

  async json(method = GET_METHOD, url = '/api', {headers = {}, body} = {}) {
    headers = Object.assign(headers, NetworkLayer.JsonHeaders);
    let response = await this.request(method, url, {headers, body});
    return await this._parseJsonBody(response);
  }

  async _parseJsonBody(res) {
    let text = await res.text();
    return text !== '' ? JSON.parse(text) : null;
  }

  remove(url) {
    return this.request(DELETE_METHOD, url);
  }

  post(url) {
    return this.request(POST_METHOD, url);
  }

  request(method = GET_METHOD, url = '/api', {headers = {}, body} = {}) {
    if (this._token) {
      headers['X-Auth-Token'] = this._token;
    }

    return fetch(url, {
      method,
      headers,
      body
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else if (response.status >= 400 && response.status < 500) {
          return Promise.reject(networkErrorFactory(response));
        } else {
          return response.json().then((data) => Promise.reject(data));
        }
      });
  }

  postFormData(url, data) {
    return this._formData(POST_METHOD, url, data);
  }

  putFormData(url, data) {
    return this._formData(PUT_METHOD, url, data);
  }

  patchFormData(url, data) {
    return this._formData(PATCH_METHOD, url, data);
  }

  /**
   *
   * @param method
   * @param url
   * @param data
   * @returns {*}
   * @private
   */
  _formData(method, url, data) {
    let formData = new FormData();

    for (let key in data) {
      if (data.hasOwnProperty(key) && data[key] !== undefined) {
        if (data[key].constructor.name === 'Array') {
          for (let i = 0; i < data[key].length; ++i) {
            formData.append(key + '[' + i + ']', data[key][i]);
          }
        } else {
          formData.append(key, data[key]);
        }
      }
    }

    return this.request(method, url, {
      body: formData
    });
  }

  patch(url, data) {
    return this.request(PATCH_METHOD, url, data);
  }

  prepareParams(params) {
    return Object.keys(params)
      .map((key) => {
        return params[key] instanceof Array
          ? params[key].map((value) => `${key}[]=${value}`).join('&')
          : `${key}=${params[key]}`
      })
      .join('&');
  }

}

export default NetworkLayer;



// WEBPACK FOOTER //
// ./src/utilites/networkLayer.js